module.exports = __webpack_public_path__ + "static/media/Manual_sencer_EN-5.9e8b1b91.png";